import { Modal } from 'cat-ecommerce-alloy';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import NonDealerShareCartModal from './NonDealerShareCartModal';
import DealerShareCartModal from './DealerShareCartModal';
import cx from 'classnames';
import { useSystemFeedback } from '@app/hooks';
import { ERROR_DOMAIN, ERROR_PATH } from '@app/constants/errorConstants';
import { DEALER } from '@app/constants/affiliations';
import styles from './ShareCartCILGModal.module.scss';

const ShareCartCILGModal = ({ isOpen, close }) => {
  const [t] = useTranslation();
  const userAffiliation = useSelector(s => s.common?.userAffiliation);
  const isDealerUser = userAffiliation === DEALER;
  const { clearError } = useSystemFeedback();

  const errorSelector = state =>
    state.errors[ERROR_DOMAIN.CHECKOUT]?.[ERROR_PATH.SHARE_CART_MODAL];

  const closeModal = () => {
    clearError(ERROR_DOMAIN.CHECKOUT, ERROR_PATH.SHARE_CART_MODAL);
    close();
  };

  return (
    <Modal
      isOpen={isOpen}
      title={t('SHARE_CART')}
      className={cx(styles['share-cart-modal'])}
      focusSelector="input"
      contentClassName={cx(styles['share-cart-modal__content'])}
    >
      {isDealerUser ? (
        <DealerShareCartModal
          isOpen={isOpen}
          errorSelector={errorSelector}
          closeModal={closeModal}
        />
      ) : (
        <NonDealerShareCartModal
          errorSelector={errorSelector}
          closeModal={closeModal}
          isOpen={isOpen}
        />
      )}
    </Modal>
  );
};

ShareCartCILGModal.propTypes = {
  isOpen: PropTypes.bool,
  close: PropTypes.func.isRequired
};

export default ShareCartCILGModal;
